/* Cheri Sorensen Art Studios - Artwork Product size gallery
   One large visual at a time + real image thumbnails on the left + size-aware AR.

   LOCKED MEDIA RULES
   ------------------
   Preferred ALT format: Artwork Title | Size-or-shared | Role

   Examples:
     Cowboy in the Mist | 24x36 | close-room
     Cowboy in the Mist | shared | artwork
     Cowboy in the Mist | 24x36 | full-room
     Cowboy in the Mist | 24x36 | ar
     Cowboy in the Mist | 16x24 | close-room
     Cowboy in the Mist | 16x24 | full-room
     Cowboy in the Mist | 16x24 | ar

   Visual sequence per selected size:
     close-room -> artwork -> full-room -> optional video

   GLB / MODEL RULES
   -----------------
   * 3D models are NEVER part of the normal desktop image sequence.
   * Model posters/previews are hidden on computers and non-AR devices.
   * The AR icon/button is shown only on mobile AR candidates (iPhone/iPad/Android)
     when the selected size has a Shopify 3D model.
   * iPhone/iPad visibility does NOT depend on model-viewer.canActivateAR, avoiding
     the Safari detection failure that can hide a valid Shopify USDZ model.
   * AR launches through ShopifyXR first. The 3D model poster is never shown in
     the ordinary gallery on desktop or mobile.
*/

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-artwork-product]').forEach(function (root) {
    var thumbs = Array.from(root.querySelectorAll('[data-artwork-thumb]'));
    var mediaItems = Array.from(root.querySelectorAll('[data-artwork-media]'));
    var optionInputs = Array.from(root.querySelectorAll('input[data-artwork-option]'));
    var sizeInputs = Array.from(root.querySelectorAll('input[data-option-kind="size"]'));
    var variantInput = root.querySelector('[data-variant-id]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var addText = root.querySelector('[data-add-to-cart-text]');
    var variantsScript = root.querySelector('[data-artwork-variants]');
    var qtyInput = root.querySelector('.artwork-product__qty-input');
    var minusButton = root.querySelector('[data-qty-minus]');
    var plusButton = root.querySelector('[data-qty-plus]');
    var finishHelpToggle = root.querySelector('[data-finish-help-toggle]');
    var finishHelp = root.querySelector('[data-finish-help]');
    var arPanel = root.querySelector('[data-artwork-ar-panel]');
    var xrButton = root.querySelector('[data-artwork-xr-launch]');
    var xrLabel = root.querySelector('[data-artwork-xr-label]');
    var arStatus = root.querySelector('[data-artwork-ar-status]');
    var arThumb = root.querySelector('[data-artwork-ar-thumb]');
    var prevButton = root.querySelector('[data-artwork-prev]');
    var nextButton = root.querySelector('[data-artwork-next]');
    var pageCount = root.querySelector('[data-artwork-page-count]');
    var defaultMediaRole = root.getAttribute('data-default-media-role') || 'artwork';
    var productTitle = root.getAttribute('data-product-title') || document.title;
    var hasSyncedMedia = false;
    var currentVisibleEntries = [];
    var currentArModelEntry = null;

    function normalizeText(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[×✕]/g, 'x')
        .replace(/\bby\b/g, 'x')
        .replace(/[“”″]/g, '"')
        .replace(/[’]/g, "'")
        .trim();
    }

    function normalizeNumber(value) {
      var n = parseFloat(value);
      if (Number.isNaN(n)) return '';
      return String(n).replace(/\.0+$/, '');
    }

    function extractSizeKey(value) {
      var text = normalizeText(value);
      var match = text.match(/(\d+(?:\.\d+)?)\s*(?:in(?:ch|ches)?|\")?\s*x\s*(\d+(?:\.\d+)?)\s*(?:in(?:ch|ches)?|\")?/i);
      if (!match) return '';
      return normalizeNumber(match[1]) + 'x' + normalizeNumber(match[2]);
    }

    function parseSizeRooms(alt) {
      var result = {};
      String(alt || '').split(';').forEach(function (part) {
        var size = extractSizeKey(part);
        var room = normalizeText(part).match(/\broom\s*[-_ ]\s*(\d+(?:\.\d+)?)(?![\d.])/);
        if (size) result[size] = room ? Number(room[1]) : null;
      });
      return result;
    }

    function detectRole(entry) {
      if (entry.type === 'model') return 'ar';
      if (entry.type === 'video' || entry.type === 'external_video') return 'video';

      var alt = normalizeText(entry.alt);
      if (/\broom\s*[-_ ]\s*\d+(?:\.\d+)?\b/.test(alt)) return 'numbered-room';
      if (/\bclose[-_ ]?room\b/.test(alt) || /\b(room|mockup)[-_ ]?1\b/.test(alt) || /\broom one\b/.test(alt)) return 'room1';
      if (/\bfull[-_ ]?room\b/.test(alt) || /\b(room|mockup)[-_ ]?2\b/.test(alt) || /\broom two\b/.test(alt)) return 'room2';
      if (/\b(artwork|painting|artwork-main|main artwork|full artwork|actual painting)\b/.test(alt)) return 'artwork';
      return '';
    }

    function roleTitle(role, type) {
      if (role === 'numbered-room') return 'Room view';
      if (role === 'room1') return 'Close room mockup';
      if (role === 'artwork') return 'Full painting';
      if (role === 'room2') return 'Full room mockup';
      if (role === 'video') return 'Artwork video';
      if (role === 'ar' || type === 'model') return 'View artwork on your wall';
      return 'Artwork view';
    }

    function roleRank(entry, selectedSize) {
      var room = selectedSize && Object.prototype.hasOwnProperty.call(entry.roomBySize, selectedSize.key)
        ? entry.roomBySize[selectedSize.key] : entry.roomNumber;
      if (room !== null && room !== undefined) return room;
      var ranks = { room1: 10, artwork: 20, room2: 30, video: 40, ar: 50 };
      return Object.prototype.hasOwnProperty.call(ranks, entry.role) ? ranks[entry.role] : 25 + entry.position / 1000;
    }

    var mediaEntries = mediaItems.map(function (element) {
      var id = element.getAttribute('data-media-id');
      var thumb = thumbs.find(function (item) {
        return item.getAttribute('data-media-id') === id;
      }) || null;
      var modelViewer = element.querySelector('model-viewer');
      var alt = element.getAttribute('data-media-alt') || '';
      var roomMatch = normalizeText(alt).match(/\broom\s*[-_ ]\s*(\d+(?:\.\d+)?)(?![\d.])/);
      var roomBySize = parseSizeRooms(alt);
      var srcText = modelViewer ? modelViewer.getAttribute('src') || '' : '';
      var entry = {
        id: id,
        element: element,
        thumb: thumb,
        modelViewer: modelViewer,
        type: element.getAttribute('data-media-type') || '',
        position: Number(element.getAttribute('data-media-position') || 0),
        alt: alt,
        roomNumber: roomMatch ? Number(roomMatch[1]) : null,
        roomBySize: roomBySize,
        sizeKeys: Object.keys(roomBySize),
        modelId: element.getAttribute('data-model-id') || '',
        // For 3D models, prefer the actual Shopify model source filename over ALT.
        // This protects size matching if an AR ALT label was accidentally swapped.
        sizeKey: (element.getAttribute('data-media-type') === 'model')
          ? (extractSizeKey(srcText) || extractSizeKey(alt))
          : (extractSizeKey(alt) || extractSizeKey(srcText)),
        groupKey: '',
        role: '',
        shared: /(^|[|\s_-])(shared|all[-_ ]?sizes)([|\s_-]|$)/.test(normalizeText(alt))
      };
      entry.role = detectRole(entry);
      return entry;
    }).sort(function (a, b) { return a.position - b.position; });

    var visualEntries = mediaEntries.filter(function (entry) { return entry.type !== 'model'; });
    var modelEntries = mediaEntries.filter(function (entry) { return entry.type === 'model'; });

    var sizeDefinitions = sizeInputs.map(function (input, index) {
      return { input: input, value: input.value, key: extractSizeKey(input.value), index: index };
    });

    var validSizeKeys = new Set(sizeDefinitions.map(function (item) { return item.key; }).filter(Boolean));
    var labelGrouping = sizeDefinitions.length > 0 && mediaEntries.some(function (entry) {
      return entry.sizeKeys.some(function (key) { return validSizeKeys.has(key); }) ||
        (entry.sizeKey && validSizeKeys.has(entry.sizeKey));
    });

    var positionGrouping = !labelGrouping && sizeDefinitions.length > 0 && modelEntries.length === sizeDefinitions.length;

    function assignFallbackRoles(entries) {
      var images = entries.filter(function (entry) { return entry.type === 'image'; });
      if (images[0] && !images[0].role) images[0].role = 'room1';
      if (images[1] && !images[1].role) images[1].role = 'artwork';
      if (images[2] && !images[2].role) images[2].role = 'room2';
    }

    if (labelGrouping) {
      sizeDefinitions.forEach(function (size) {
        var group = mediaEntries.filter(function (entry) {
          return entry.sizeKeys.indexOf(size.key) !== -1 || entry.sizeKey === size.key || entry.shared;
        });
        group.forEach(function (entry) {
          if (!entry.shared && !entry.groupKey) entry.groupKey = size.key;
        });
        assignFallbackRoles(group);
      });
    } else if (positionGrouping) {
      var cursor = 0;
      sizeDefinitions.forEach(function (size, sizeIndex) {
        var endModel = modelEntries[sizeIndex];
        var group = mediaEntries.filter(function (entry) {
          return entry.position >= cursor && entry.position <= endModel.position;
        });
        group.forEach(function (entry) { entry.groupKey = size.key || ('size-' + sizeIndex); });
        assignFallbackRoles(group);
        cursor = endModel.position + 1;
      });
    } else {
      assignFallbackRoles(mediaEntries);
    }

    mediaEntries.forEach(function (entry) {
      if (!entry.thumb) return;
      entry.thumb.setAttribute('data-media-role', entry.role || 'other');
      var title = roleTitle(entry.role, entry.type);
      entry.thumb.setAttribute('aria-label', title);
      entry.thumb.setAttribute('title', title);
    });

    function selectedSizeDefinition() {
      var checked = sizeInputs.find(function (input) { return input.checked; });
      if (!checked) return null;
      return { value: checked.value, key: extractSizeKey(checked.value), input: checked };
    }

    function entryBelongsToSelectedSize(entry, selectedSize) {
      if (!selectedSize || !selectedSize.key) return true;
      if (entry.shared) return true;
      if (labelGrouping) return entry.sizeKeys.indexOf(selectedSize.key) !== -1 ||
        entry.sizeKey === selectedSize.key;
      if (positionGrouping) return entry.groupKey === selectedSize.key;
      return true;
    }

    function orderedEntriesForSelectedSize(selectedSize) {
      var entries = visualEntries.filter(function (entry) {
        return entryBelongsToSelectedSize(entry, selectedSize);
      });
      // With labelled sizes, never display images from a different size.
      if (!entries.length && !labelGrouping) entries = visualEntries.slice();
      return entries.slice().sort(function (a, b) {
        var rankDiff = roleRank(a, selectedSize) - roleRank(b, selectedSize);
        return rankDiff || (a.position - b.position);
      });
    }

    function modelForSelectedSize(selectedSize) {
      var matches = modelEntries.filter(function (entry) {
        return entryBelongsToSelectedSize(entry, selectedSize);
      });
      if (matches.length) return matches[0];
      if (modelEntries.length === 1) return modelEntries[0];
      return null;
    }

    function pauseEntry(entry) {
      if (!entry) return;
      var video = entry.element.querySelector('video');
      if (video && !video.paused) video.pause();
    }

    function updateNavigation(activeEntry) {
      if (!currentVisibleEntries.length) return;
      var index = currentVisibleEntries.findIndex(function (entry) {
        return activeEntry && entry.id === activeEntry.id;
      });
      if (index < 0) index = 0;

      if (prevButton) prevButton.disabled = index <= 0;
      if (nextButton) nextButton.disabled = index >= currentVisibleEntries.length - 1;
      if (pageCount) pageCount.textContent = (index + 1) + ' / ' + currentVisibleEntries.length;
    }

    function activateMedia(mediaId) {
      var activeEntry = null;
      mediaEntries.forEach(function (entry) {
        var active = entry.id === String(mediaId);
        entry.element.hidden = !active;
        entry.element.classList.toggle('is-active', active);
        if (!active) pauseEntry(entry);
        if (entry.thumb) {
          entry.thumb.classList.toggle('is-active', active);
          if (active) entry.thumb.setAttribute('aria-current', 'true');
          else entry.thumb.removeAttribute('aria-current');
        }
        if (active) activeEntry = entry;
      });
      if (arThumb) arThumb.classList.remove('is-active');
      updateNavigation(activeEntry);
      return activeEntry;
    }

    function pickDefaultEntry(entries, preferredRole) {
      if (entries.some(function (entry) { return entry.roomNumber !== null; })) return entries[0] || null;
      var exact = entries.find(function (entry) { return entry.role === preferredRole; });
      if (exact) return exact;
      var artwork = entries.find(function (entry) { return entry.role === 'artwork'; });
      if (artwork) return artwork;
      var images = entries.filter(function (entry) { return entry.type === 'image'; });
      if (images[1]) return images[1];
      if (images[0]) return images[0];
      return entries[0] || null;
    }

    function setArControlsVisible(visible, selectedSize) {
      if (arThumb) {
        arThumb.hidden = !visible;
        arThumb.setAttribute('aria-hidden', visible ? 'false' : 'true');
        arThumb.tabIndex = visible ? 0 : -1;
      }
      if (arPanel) {
        arPanel.hidden = !visible;
        arPanel.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
      if (visible && xrLabel) {
        xrLabel.textContent = selectedSize && selectedSize.value
          ? 'View ' + selectedSize.value + ' on your wall'
          : 'View on your wall';
      }
    }

    function isIosArDevice() {
      var ua = navigator.userAgent || '';
      var platform = navigator.platform || '';
      return /iPad|iPhone|iPod/i.test(ua) ||
        (platform === 'MacIntel' && Number(navigator.maxTouchPoints || 0) > 1);
    }

    function isAndroidArDevice() {
      return /Android/i.test(navigator.userAgent || '');
    }

    function isMobileArCandidate() {
      return isIosArDevice() || isAndroidArDevice();
    }

    function refreshArSupport(selectedSize) {
      var entry = currentArModelEntry;
      var viewer = entry && entry.modelViewer;

      // iOS/iPadOS: Shopify creates the USDZ Quick Look source from the GLB.
      // Do not require model-viewer.canActivateAR; Safari/iOS can report false
      // even when ShopifyXR + USDZ AR is available.
      var supported = !!entry && (
        isIosArDevice() ||
        (isAndroidArDevice() && (
          (viewer && viewer.canActivateAR === true) ||
          !!window.ShopifyXR
        ))
      );

      setArControlsVisible(supported, selectedSize);
      return supported;
    }

    function scheduleArSupportChecks(selectedSize) {
      setArControlsVisible(false, selectedSize);

      // Desktop/laptop never gets an AR control.
      if (!isMobileArCandidate()) return;

      // iPhone/iPad can show the control immediately when a matching Shopify
      // model exists. Android gets a few short checks while ShopifyXR/model-viewer loads.
      if (isIosArDevice()) {
        refreshArSupport(selectedSize);
        return;
      }

      [0, 250, 750, 1500, 3000].forEach(function (delay) {
        window.setTimeout(function () { refreshArSupport(selectedSize); }, delay);
      });
    }

    function updateArForSize(selectedSize) {
      currentArModelEntry = modelForSelectedSize(selectedSize);
      if (!currentArModelEntry || !currentArModelEntry.modelId) {
        if (xrButton) xrButton.setAttribute('data-model-id', '');
        setArControlsVisible(false, selectedSize);
        return;
      }

      if (xrButton) {
        xrButton.setAttribute('data-model-id', currentArModelEntry.modelId);
        xrButton.setAttribute('data-shopify-model3d-id', currentArModelEntry.modelId);
      }
      if (arThumb) arThumb.setAttribute('data-shopify-model3d-id', currentArModelEntry.modelId);
      scheduleArSupportChecks(selectedSize);
    }

    function syncMediaToSelectedSize() {
      if (!mediaEntries.length) return;
      var selectedSize = selectedSizeDefinition();
      var currentActive = visualEntries.find(function (entry) {
        return entry.element.classList.contains('is-active') && !entry.element.hidden;
      });
      var preferredRole = hasSyncedMedia && currentActive && currentActive.role
        ? currentActive.role
        : defaultMediaRole;

      currentVisibleEntries = orderedEntriesForSelectedSize(selectedSize);
      var visibleIds = new Set(currentVisibleEntries.map(function (entry) { return entry.id; }));
      var thumbContainer = root.querySelector('[data-artwork-media-icons]');
      if (thumbContainer) currentVisibleEntries.forEach(function (entry) {
        if (entry.thumb) thumbContainer.appendChild(entry.thumb);
      });
      if (thumbContainer && arThumb) thumbContainer.appendChild(arThumb);

      mediaEntries.forEach(function (entry) {
        var visibleVisual = entry.type !== 'model' && visibleIds.has(entry.id);
        if (entry.thumb) entry.thumb.hidden = !visibleVisual;
        if (!visibleVisual) {
          entry.element.hidden = true;
          entry.element.classList.remove('is-active');
          pauseEntry(entry);
        }
      });

      var nextActive = currentVisibleEntries.find(function (entry) {
        return currentActive && entry.id === currentActive.id;
      });

      if (!nextActive && hasSyncedMedia && currentActive && currentActive.role) {
        if (currentActive.roomNumber !== null) nextActive = currentVisibleEntries.find(function (entry) {
          return entry.roomNumber === currentActive.roomNumber;
        });
      }

      if (!nextActive && hasSyncedMedia && currentActive && currentActive.role) {
        nextActive = currentVisibleEntries.find(function (entry) {
          return entry.role === currentActive.role;
        });
      }

      if (!nextActive) nextActive = pickDefaultEntry(currentVisibleEntries, preferredRole);
      if (nextActive) activateMedia(nextActive.id);
      updateArForSize(selectedSize);
      hasSyncedMedia = true;
    }

    function moveMedia(direction) {
      if (!currentVisibleEntries.length) return;
      var activeEntry = visualEntries.find(function (entry) {
        return entry.element.classList.contains('is-active') && !entry.element.hidden;
      });
      var index = currentVisibleEntries.findIndex(function (entry) {
        return activeEntry && entry.id === activeEntry.id;
      });
      if (index < 0) index = 0;
      var nextIndex = Math.max(0, Math.min(currentVisibleEntries.length - 1, index + direction));
      if (nextIndex !== index) activateMedia(currentVisibleEntries[nextIndex].id);
    }

    function launchCurrentAr() {
      var entry = currentArModelEntry;
      if (!entry || !entry.modelId) return;

      if (arStatus) arStatus.textContent = '';

      // ShopifyXR is Shopify's supported AR launcher for iOS Quick Look and
      // Android Scene Viewer. Use it first so a hidden model poster is not needed.
      if (window.ShopifyXR && typeof window.ShopifyXR.launchXR === 'function') {
        try {
          window.ShopifyXR.launchXR({
            model3dId: Number(entry.modelId),
            title: productTitle
          });
          return;
        } catch (error) {}
      }

      // Fallback only after an explicit AR click. This never reveals the model
      // inside the normal product gallery.
      var viewer = entry.modelViewer;
      if (viewer && typeof viewer.activateAR === 'function') {
        try {
          var activation = viewer.activateAR();
          if (activation && typeof activation.catch === 'function') {
            activation.catch(function () {
              if (arStatus) arStatus.textContent = 'AR could not be opened on this device/browser.';
            });
          }
          return;
        } catch (error) {}
      }

      if (arStatus) arStatus.textContent = 'AR could not be opened on this device/browser.';
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (thumb.hidden) return;
        activateMedia(thumb.getAttribute('data-media-id'));
      });
    });

    if (arThumb) arThumb.addEventListener('click', launchCurrentAr);
    if (xrButton) xrButton.addEventListener('click', launchCurrentAr);
    if (prevButton) prevButton.addEventListener('click', function () { moveMedia(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { moveMedia(1); });

    modelEntries.forEach(function (entry) {
      if (entry.modelViewer) {
        entry.modelViewer.addEventListener('load', function () {
          refreshArSupport(selectedSizeDefinition());
        });
      }
    });

    if (minusButton && qtyInput) {
      minusButton.addEventListener('click', function () {
        var current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = Math.max(1, current - 1);
      });
    }

    if (plusButton && qtyInput) {
      plusButton.addEventListener('click', function () {
        var current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = current + 1;
      });
    }

    if (finishHelpToggle && finishHelp) {
      finishHelpToggle.addEventListener('click', function () {
        var isOpen = finishHelpToggle.getAttribute('aria-expanded') === 'true';
        finishHelpToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        finishHelp.hidden = isOpen;
      });
    }

    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent); }
      catch (e) { console.error('Artwork variant data could not be read.', e); }
    }

    function selectedByPosition() {
      var selections = {};
      optionInputs.forEach(function (input) {
        if (input.checked) selections[Number(input.getAttribute('data-option-position'))] = input.value;
      });
      return selections;
    }

    function findVariantForSize(sizeInput, selections) {
      var sizePosition = Number(sizeInput.getAttribute('data-option-position'));
      var sizeValue = sizeInput.value;
      return variants.find(function (variant) {
        return variant.options.every(function (optionValue, index) {
          var position = index + 1;
          if (position === sizePosition) return optionValue === sizeValue;
          if (Object.prototype.hasOwnProperty.call(selections, position)) return optionValue === selections[position];
          return true;
        });
      });
    }

    function updateSizeAvailabilityAndPrices() {
      if (!variants.length) return;
      var selections = selectedByPosition();
      sizeInputs.forEach(function (sizeInput) {
        var label = sizeInput.closest('.artwork-product__size-choice');
        if (!label) return;
        var priceEl = label.querySelector('[data-size-price]');
        if (!priceEl) return;
        var variant = findVariantForSize(sizeInput, selections);
        if (!variant) {
          priceEl.textContent = 'Unavailable';
          sizeInput.disabled = true;
          label.classList.add('is-unavailable');
          return;
        }
        priceEl.textContent = variant.available ? variant.formatted_price : 'Sold out';
        sizeInput.disabled = !variant.available;
        label.classList.toggle('is-unavailable', !variant.available);
      });

      var selectedSize = root.querySelector('input[data-option-kind="size"]:checked');
      if (selectedSize && selectedSize.disabled) {
        var firstAvailable = sizeInputs.find(function (input) { return !input.disabled; });
        if (firstAvailable) firstAvailable.checked = true;
      }
    }

    function updateSelectedVariant() {
      if (!variants.length || !optionInputs.length) {
        syncMediaToSelectedSize();
        return;
      }

      updateSizeAvailabilityAndPrices();
      var selections = selectedByPosition();
      var variant = variants.find(function (item) {
        return item.options.every(function (value, index) {
          return selections[index + 1] === value;
        });
      });

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        syncMediaToSelectedSize();
        return;
      }

      if (variantInput) {
        var previousVariantId = String(variantInput.value);
        variantInput.value = variant.id;
        if (previousVariantId !== String(variant.id)) {
          variantInput.dispatchEvent(new Event('input', { bubbles: true }));
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      syncMediaToSelectedSize();
    }

    var finishInputs = Array.from(root.querySelectorAll('input[data-option-kind="finish"]'));
    var stretchedInput = finishInputs.find(function (input) {
      return normalizeText(input.value).indexOf('stretched') !== -1;
    });
    if (stretchedInput && !finishInputs.some(function (input) { return input.checked; })) stretchedInput.checked = true;

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateSelectedVariant);
    });

    updateSelectedVariant();
  });
});
